<template>
    <b-alert
        class="mt-2"
        variant="secondary"
        :show="true"
    >
        <h2>Register Now for the {{ semester.label }} Semester!</h2>
        <button
            class="sc-btn pill"
            @click="download()"
        >
            <font-awesome-icon icon="file-pdf" class="mr-2" />
            Download Class Descriptions PDF
        </button>
    </b-alert>
</template>
<script>
import { base_url } from "@/api/getBaseUrl"
import { downloadFile } from "@/api/downloadFile"
import { mapState } from 'vuex';

export default {
    props: ["semester"],
    methods: {
        download() {
            downloadFile(
                `${base_url}/api/pdf/class-descriptions/all-descriptions.pdf?semester_id=${this.semester.id}&token=${this.token}`,
                `${this.group.group_name}-${this.semester.label}-all-class-descriptions.pdf`
            );
        }
    },
    computed: mapState(["group", "token"])
}
</script>